import { render, staticRenderFns } from "./TopSellerList.vue?vue&type=template&id=1468d420&scoped=true&"
import script from "./TopSellerList.vue?vue&type=script&lang=js&"
export * from "./TopSellerList.vue?vue&type=script&lang=js&"
import style0 from "./TopSellerList.vue?vue&type=style&index=0&id=1468d420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1468d420",
  null
  
)

export default component.exports